import { Home, Building2, Building, Trees } from "lucide-react";

// Shared property-type → icon + color coding (used by Market Intelligence bands + Homes tab).
export const PROPERTY_META = {
  "Single Family": { icon: Home, cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30", dot: "bg-emerald-400" },
  "Manufactured": { icon: Home, cls: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30", dot: "bg-emerald-400" },
  "Condo": { icon: Building2, cls: "text-sky-400 bg-sky-500/10 border-sky-500/30", dot: "bg-sky-400" },
  "Apartment": { icon: Building2, cls: "text-sky-400 bg-sky-500/10 border-sky-500/30", dot: "bg-sky-400" },
  "Multi-Family": { icon: Building2, cls: "text-indigo-400 bg-indigo-500/10 border-indigo-500/30", dot: "bg-indigo-400" },
  "Townhouse": { icon: Building, cls: "text-violet-400 bg-violet-500/10 border-violet-500/30", dot: "bg-violet-400" },
  "Land": { icon: Trees, cls: "text-amber-400 bg-amber-500/10 border-amber-500/30", dot: "bg-amber-400" },
};

export const DEFAULT_PT = { icon: Home, cls: "text-muted-foreground bg-surface border-border", dot: "bg-muted-foreground" };

export const ptMeta = (t) => PROPERTY_META[t] || DEFAULT_PT;

// Selectable property types (drives the one-click filter chips).
export const PROPERTY_TYPES = ["Single Family", "Condo", "Townhouse", "Multi-Family", "Land"];

// Session-persisted preferred property-type filter (shared across Homes tab + Market drill-down).
const PT_KEY = "luxora_property_type";
export const getPreferredType = () => {
  try { return sessionStorage.getItem(PT_KEY) || ""; } catch { return ""; }
};
export const setPreferredType = (t) => {
  try { t ? sessionStorage.setItem(PT_KEY, t) : sessionStorage.removeItem(PT_KEY); } catch { /* ignore */ }
};
